import { ArrayStringFilterOperator } from "./views/advanced-filters/array-string-filter";
import { BooleanFilterOperator } from "./views/advanced-filters/boolean-filter";
import { DateFilterOperator } from "./views/advanced-filters/date-filter";
import { NumberFilterOperator } from "./views/advanced-filters/number-filter";

import { AdvancedFilterType } from "./views/advanced-filters/generic-advanced-filter-data";
import { AdvancedFilterData } from "./views/views";

export enum DispositionFilter {
  /**
   * All returns where allProductsDispositionCompleted is `false`
   */
  INCLUDE = "INCLUDE",
  /**
   * All returns where allProductsDispositionCompleted is `true` or `null`
   */
  EXCLUDE = "EXCLUDE",
}

export enum ExchangePaymentStatus {
  PENDING = "pending",
  COMPLETE = "complete",
}

export enum ReviewingPartyFilter {
  MERCHANT_REVIEW = "merchant_review",
  NOT_MERCHANT_REVIEW = "not_merchant_review",
}

export enum ReturnTableFilterNames {
  RETURN_TYPE = "returnType",
  CREATED_AT = "createdAt",
  PROCESSED_AT = "processedAt",
  STATUS = "status",
  ZIP_CODE = "zipCode",
  EXCHANGE_PAYMENT_STATUS = "exchangePaymentStatus",
  ALL_PRODUCTS_DISPOSITION_COMPLETED = "allProductsDispositionCompleted",
  TAGS = "tags",
  REVIEWING_PARTY = "reviewingParty",
  IS_REPAIR = "isRepair",
  SHIPMENT_STATUS = "shipmentStatus",
  SHIPMENT_DAYS_SINCE_LAST_UPDATE = "shipmentDaysSinceLastUpdate",
  PARTIALLY_PROCESSED = "partiallyProcessed",
  FAILED_RMA_CREATION = "failedRmaCreation",
  PROVISIONING = "provisioning",
  DROPOFF_STATUS = "dropoffStatus",
  SHIPPING_COUNTRY = "shippingCountry",
  PRODUCT_SKU = "productSku",
}

export const returnTableFilterData = {
  [ReturnTableFilterNames.CREATED_AT]: {
    name: ReturnTableFilterNames.CREATED_AT,
    type: AdvancedFilterType.DATE,
    value: null,
    operator: DateFilterOperator.WITHIN,
  },
  [ReturnTableFilterNames.PROCESSED_AT]: {
    name: ReturnTableFilterNames.PROCESSED_AT,
    type: AdvancedFilterType.DATE,
    value: null,
    operator: DateFilterOperator.WITHIN,
  },
  [ReturnTableFilterNames.STATUS]: {
    name: ReturnTableFilterNames.STATUS,
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  [ReturnTableFilterNames.ZIP_CODE]: {
    name: ReturnTableFilterNames.ZIP_CODE,
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: [],
    operator: ArrayStringFilterOperator.STARTS_WITH,
  },
  [ReturnTableFilterNames.RETURN_TYPE]: {
    name: ReturnTableFilterNames.RETURN_TYPE,
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  [ReturnTableFilterNames.EXCHANGE_PAYMENT_STATUS]: {
    name: ReturnTableFilterNames.EXCHANGE_PAYMENT_STATUS,
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  [ReturnTableFilterNames.ALL_PRODUCTS_DISPOSITION_COMPLETED]: {
    name: ReturnTableFilterNames.ALL_PRODUCTS_DISPOSITION_COMPLETED,
    type: AdvancedFilterType.BOOLEAN,
    value: null,
    operator: BooleanFilterOperator.IS,
  },
  [ReturnTableFilterNames.TAGS]: {
    name: ReturnTableFilterNames.TAGS,
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: [],
    operator: ArrayStringFilterOperator.ALL_OF,
  },
  [ReturnTableFilterNames.REVIEWING_PARTY]: {
    name: ReturnTableFilterNames.REVIEWING_PARTY,
    type: AdvancedFilterType.BOOLEAN,
    value: null,
    operator: BooleanFilterOperator.IS,
  },
  [ReturnTableFilterNames.IS_REPAIR]: {
    name: ReturnTableFilterNames.IS_REPAIR,
    type: AdvancedFilterType.BOOLEAN,
    value: null,
    operator: BooleanFilterOperator.IS,
  },
  [ReturnTableFilterNames.SHIPMENT_STATUS]: {
    name: ReturnTableFilterNames.SHIPMENT_STATUS,
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  [ReturnTableFilterNames.SHIPMENT_DAYS_SINCE_LAST_UPDATE]: {
    name: ReturnTableFilterNames.SHIPMENT_DAYS_SINCE_LAST_UPDATE,
    type: AdvancedFilterType.NUMBER,
    value: null,
    operator: NumberFilterOperator.GREATER_THAN,
  },
  [ReturnTableFilterNames.PARTIALLY_PROCESSED]: {
    name: ReturnTableFilterNames.PARTIALLY_PROCESSED,
    type: AdvancedFilterType.BOOLEAN,
    value: true,
    operator: BooleanFilterOperator.IS,
  },
  [ReturnTableFilterNames.FAILED_RMA_CREATION]: {
    name: ReturnTableFilterNames.FAILED_RMA_CREATION,
    type: AdvancedFilterType.BOOLEAN,
    value: true,
    operator: BooleanFilterOperator.IS,
  },
  [ReturnTableFilterNames.PROVISIONING]: {
    name: ReturnTableFilterNames.PROVISIONING,
    type: AdvancedFilterType.BOOLEAN,
    value: null,
    operator: BooleanFilterOperator.IS,
  },
  [ReturnTableFilterNames.DROPOFF_STATUS]: {
    name: ReturnTableFilterNames.DROPOFF_STATUS,
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  [ReturnTableFilterNames.SHIPPING_COUNTRY]: {
    name: ReturnTableFilterNames.SHIPPING_COUNTRY,
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  [ReturnTableFilterNames.PRODUCT_SKU]: {
    name: ReturnTableFilterNames.PRODUCT_SKU,
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: [],
    operator: ArrayStringFilterOperator.STARTS_WITH,
  },
} satisfies Record<ReturnTableFilterNames, AdvancedFilterData>;
